import React from "react";
import { useStore, useSelector } from "react-redux";
import { Color } from "cesium";
import moment from "moment";
import { GeoJsonDataSource } from "resium";
import {
  p1StartTime,
  p1EndTime,
  p2StartTime,
  p2EndTime,
  p3StartTime,
  p3EndTime,
} from "@/models/layer";

function BufferRingLayer() {
  const { select } = useStore();
  const time = useSelector(select.layer.selectTime);
  const mode = useSelector((state) => state.panel.mode);
  const date = moment(time);

  if (
    mode !== "planning" &&
    !(
      date.isBetween(p1StartTime, p1EndTime) ||
      date.isBetween(p2StartTime, p2EndTime) ||
      date.isBetween(p3StartTime, p3EndTime)
    )
  ) {
    return null;
  }
  return (
    <GeoJsonDataSource
      key={`layer-buffer-rings-1`}
      name={"layer-buffer-rings-1"}
      show={true}
      data={`/geojson/buffer/v3_irregular_NO_ICE_passage_buffer_${time}.geojson`}
      fill={Color.TRANSPARENT}
      stroke={Color.FUCHSIA}
      strokeWidth={10}
    />
  );
}

export default BufferRingLayer;
